import React, { useState } from "react";
import AlertIconSVG from "assets/svg/alert-info-icon-sm-svg";
import { useDropzone } from "react-dropzone";
import PDFColoredIconSVG from "assets/svg/pdf-icon-colored";
import { useDialogHook } from "utils/customhooks";
import UploadSizeModal from "components/file-upload/upload-size-modal";
import { maxUploadDocx } from "utils/constant";
import { useTranslation } from "react-i18next";
import ModalHeader from "components/global/modal-header";
import Modal from "components/global/modal";
import Button from "components/button/button";
import LoadingIndicator from "assets/svg/loading-indicator";

const MilestoneUpload = ({ hide,profile_id, ...props }, ref) => {
  const { t } = useTranslation();
  const { http } = global.services;
  const uploadSizeModal = useDialogHook(UploadSizeModal);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [file, setFile] = useState(null); // <-- single file state
  const [error, setError] = useState(null);

  const showUploadSizeModalError = () => {
    uploadSizeModal({}, (callback) => {
      console.log("callback", callback);
    });
  };

  const onDrop = (acceptedFiles) => {
    if (acceptedFiles.length === 0) return; // no valid files dropped

    const selectedFile = acceptedFiles[0];

    if (selectedFile.size > maxUploadDocx) {
      showUploadSizeModalError();
      return;
    }

    const randomId = Math.random().toString(36).substring(2, 7);
    selectedFile.progress = 1;
    selectedFile.progressId = randomId;

    setFile(selectedFile); // <-- store only one file
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    multiple: false, // <-- only allow one file
    accept: {
      "application/msword": [".doc"],
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [
        ".docx",
      ],
    },
  });

  const uploadFileToLaravel = async () => {
    if (!file) {
      setError("No file selected");
      return;
    }

    setSubmitLoading(true);
    setError(null);

    const formData = new FormData();
    formData.append("file", file); // 'file' is the field Laravel expects
    formData.append("profile_id",profile_id);
    // Add other fields if needed: formData.append('user_id', 123);

    try {
      const response = await http.post(
        "public/milestones/uploadDoc", // <-- your Laravel route
        formData
      );

      console.log("Upload success:", response.data);
      hide({success:true})
      setFile(null); // reset selected file
    } catch (err) {
      console.error("Upload error:", err);
      if (err && err.status === 422) {
        // The error message from backend JSON
        setError(err.data.error || "Validation error");
      } else {
        setError("File upload failed. Please try again.");
      }
    } finally {
      setSubmitLoading(false);
    }
  };

  const Footer = () => (
    <div className="w-full flex items-center justify-end space-x-2">
      <Button
        buttonName={t("cancel")}
        buttonClass="bg-thBg py-4 px-8 hover:bg-gray min-w-[7rem]"
        buttonTextClass="text-black text-sm font-semibold"
        onClick={hide}
        disabled={submitLoading}
      />
      <Button
        key="save-btn-category"
        buttonName={t("save")}
        buttonClass="bg-primary py-4 px-8 hover:bg-darkPrimary min-w-[7rem]"
        buttonTextClass="w-full text-white text-sm font-semibold flex items-center justify-center"
        loadingIcon={
          submitLoading ? (
            <LoadingIndicator className="text-white w-4 h-4 ml-2" />
          ) : null
        }
        onClick={uploadFileToLaravel}
      />
    </div>
  );

  return (
    <Modal
      footer={<Footer />}
      width="w-19/20 md:w-16/20 2md:w-12/20 3md:w-9/20 1xl:w-8/20"
      contentClassName="rounded-lg overflow-auto custom-scroll"
      wrapperClassName="overflow-visible"
      footerClass="border-t border-gray"
    >
      <ModalHeader
        title="Upload Milestones"
        hide={hide}
        // showPopInfo
        // popInfoType="add_milestone"
      />

      <div className="relative h-full image-dropzone flex mx-5 mb-5">
        <div {...getRootProps()}>
          <input ref={ref} {...getInputProps()} />
          <div className="add-photo-dropzone flex flex-wrap justify-center px-2 py-6 rounded cursor-pointer">
            {/* <PDFColoredIconSVG /> */}
            <p className="text-sm text-gray-500 mt-2 text-center">
              Drag & Drop to Upload Documents or
              <span className="text-blue"> {t("browseFiles")}</span>
            </p>
          </div>
        </div>
      </div>

      {/* Show selected Word file */}
      {file && (
        <div className="mx-5 mb-5">
          <p className="text-sm font-semibold mb-2">Upload Document:</p>
          <div className="flex items-center justify-between border p-2 rounded">
            <span>{file.name}</span>
            <span className="text-xs text-gray-500">
              {(file.size / 1024 / 1024).toFixed(2)} MB
            </span>
          </div>
        </div>
      )}

      {error && (
        <p className="input-error-message mb-2 flex ml-4">
          <AlertIconSVG /> {error}
        </p>
      )}
    </Modal>
  );
};

const DropzoneUploadMilestone = React.forwardRef(MilestoneUpload);
export default DropzoneUploadMilestone;